import styles from "./index.module.scss";
import { Col, Row,Button } from "antd";
import MainTitle from "@/components/MainTitle";
import mapUrl from "@/assets/images/home/map.png";
import intl from "react-intl-universal";
import TitleWhithLine from "@/components/TitleWhithLine";
const Together = () => {
  return (
    <div className="container">
      <h1 style={{ textAlign: "center", margin: "60px 0" }}>
        {intl.get("Home.Our open ecosystem")}
      </h1>
      <Row gutter={100}>
        <Col
          span={14}
          className="wow animate__fadeInLeft"
          data-wow-duration="1s"
        >
          <div className={styles.contentBox}>
            {/* <MainTitle style={{fontSize:'16px'}} title="Home.Open Geospatial Engine" />
						<MainTitle title="Open Geospatial Collaboration" /> */}
            <h2>{intl.get("Home.Open Geospatial Engine")}</h2>
            <h2>{intl.get("Open Geospatial Collaboration")}</h2>
            <div className={styles.textBox}>
              <a href="https://www.openge.org.cn/develop" target="_blank">
                {intl.get("Home.Open Geospatial Engine")}
              </a>
              {intl.get("Home.toghterDes")}
            </div>
            <div className={styles.more}>
			<Button type="primary" target="_blank" href="https://www.openge.org.cn/develop">
					{intl.get("Home.More")} →
				</Button>
            </div>
          </div>
        </Col>
        <Col
          span={10}
          className="wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div className={styles.imgBox}>
            <img src={mapUrl} />
          </div>
        </Col>
      </Row>

      {/* 遥感教育云计算平台模块暂时屏蔽。 */}
    </div>
  );
};
export default Together;
